import type { AuditionStage } from './state-machine.js'

// Operational wind-down, independent of feature flags and admin previews.
export const AUDITION_INTAKE_CLOSED = true
export const INTAKE_CLOSED_MESSAGE =
  'New applications and purchases are closed. Existing payments and booked calls are still being honored.'

/** Keep fulfillment for paid applicants and previously booked calls. */
export function canFulfillExistingApplication(submission: {
  stage: AuditionStage
  stripePaymentIntentId: string | null
}): boolean {
  return (
    submission.stage === 'paid_pending_call' ||
    submission.stage === 'client' ||
    submission.stage === 'vibe_call_booked' ||
    // Both stages are reachable without paying: `payment_unlocked` only
    // permits a payment, which can no longer be made, so it is an
    // obligation only once a payment actually landed.
    ((submission.stage === 'audition_completed' ||
      submission.stage === 'payment_unlocked') &&
      Boolean(submission.stripePaymentIntentId))
  )
}
